/**
 */
import React, { Component, PropTypes } from 'react';
import './shortcutbutton.scss';

class ShortcutButton extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isVisible: true,
      isActiveState: this.props.isActiveState,
    };

    this.clickHandler = this.clickHandler.bind(this);
  }

  clickHandler() {
    this.setState({ isActiveState: !this.state.isActiveState });
    this.props.clickHandler(this.props.id);
  }

  render() {
    // create css for te different states (visible, active)
    let anim = ' sb-'.concat(this.props.id).concat('-invisible');
    let abanner = ' banner-'.concat(this.props.id).concat('-invisible');
    if (this.props.isVisible) {
      anim = ' sb-'.concat(this.props.id).concat('-visible');
      abanner = ' banner-'.concat(this.props.id).concat('-visible');
    }
    let active = ' sb-'.concat(this.props.id).concat('-inactive');
    if (this.state.isActiveState) {
      active = ' sb-'.concat(this.props.id).concat('-active');
    }
    const icon = 'icon--large text--center pt-- filter--flat '.concat(this.props.icon);

    return (
      <div>
        <div className={'shortcut-button'.concat(anim)} onClick={this.clickHandler} title={this.props.label}>
          {this.props.labelShow ? <div className={'shortcut-banner'.concat(abanner)}>{this.props.label || this.props.id}</div> : null}
          <div className={'shortcut-inside'.concat(active)}>
            <i className={icon}></i>
          </div>
          {this.props.children}
        </div>
      </div>
    );
  }
}

ShortcutButton.propTypes = {
  id: PropTypes.string,
  icon: PropTypes.string,
  label: PropTypes.string,
  labelShow: PropTypes.bool,
};

ShortcutButton.defaultProps = {
  id: '',
  icon: '',
  label: '',
  labelShow: true,
};

export default ShortcutButton;



/** WEBPACK FOOTER **
 ** ./apps/maptool/components/ShortcutMenu/ShortcutButton.js
 **/